export const CLOSE_MODAL = 'SERVICES/MODALS/CLOSE_MODAL';
export const CLOSE_MODALS = 'SERVICES/MODALS/CLOSE_MODALS';
export const OPEN_MODAL = 'SERVICES/MODALS/OPEN_MODAL';
